module.exports = __webpack_public_path__ + "static/media/architectContentOne.00cd042e.png";